import { Checkbox } from 'primereact/checkbox'
import { FC } from 'react'
import styled from 'styled-components'

interface ICheckBox {
  checked: boolean
  onChange: (value: any) => void
}

export const CheckBox: FC<ICheckBox> = ({ checked, onChange }) => {
  return (
    <Div>
      <Checkbox inputId="binary" checked={checked} onChange={(e) => onChange(e.checked)} />
    </Div>
  )
}

const Div = styled.div`
  height: 20px;

  .p-checkbox {
    display: block;
  }
`
